

export const HARDCODED_POOL_APR = {
 '8453-0xa3c2fb43c7445d8ff8bd93dac53d98bde7444020': [
   { title: 'Swap Fee APR', apr: 2.1904}, 
   { title: 'Reward APR', apr: 0.15 }, 
 ],
 '8453-0xe8598ada6b7a1a41f78c54a51cf15bd2eb79a8e0': [
  { title: 'Swap Fee APR', apr: .31}, 
  { title: 'Reward APR', apr: 0.00 }, 
 ],
};





// MobilePoolData (app/pools/layout/liquidityv3/table/mobilepoollistitemv3)
// V3 pool table at app/pools/layout/liquidityv3/table. 
// content at app/home/secitons/section2featured/featuredpoolscard. 
// dashfeaturedcontent at app/dashboard/components/dashboardv3/featuredpools/dashfeaturedcontent. 
// usetoppools at lib/util/usetoppools.ts
// useUserV3State at lib/user 